import { defineStore } from 'pinia';

export const useUxStore = defineStore('uxStore', {
    state: () => ({
        loadingCount: 0,
        error: null,
        parsingErrors: {}, // Add this to store the parsing errors
    }),
    getters: {
        isLoading: (state) => state.loadingCount > 0,
        hasParsingError: (state) => (fieldName) => !!state.parsingErrors[fieldName],
        getParsingErrorMessage: (state) => (fieldName) => state.parsingErrors[fieldName] || '',
        hasAnyParsingErrors: (state) => Object.keys(state.parsingErrors).length > 0,
    },
    actions: {
        startLoading() {
            this.loadingCount++;
        },
        stopLoading() {
            if (this.loadingCount > 0) this.loadingCount--;
        },
        setError(message) {
            if (typeof message === "string") {
                this.error = message;
                return;
            }

            const normalized = message?.detail || message?.title || message?.message;
            this.error = typeof normalized === "string" && normalized.length > 0
                ? normalized
                : "Ein unerwarteter Fehler ist aufgetreten.";
        },
        clearError() {
            this.error = null;
        },
        // New actions for parsing errors
        setParsingErrors(errors) {
            this.parsingErrors = errors || {};
        },
        clearParsingErrors() {
            this.parsingErrors = {};
        },
        clearParsingError(fieldName) {
            if (this.parsingErrors[fieldName]) {
                const newErrors = { ...this.parsingErrors };
                delete newErrors[fieldName];
                this.parsingErrors = newErrors;
            }
        },
    },
});
